
let FaqService = function (Restangular) {
  const ServiceAPI = Restangular.all('common_questions');

    let getFaqList = () => {
      return ServiceAPI.customGET();
    }

    let getLogDetails = (id) => {
      return Restangular.all('admin/common_questions_logs').customGET(id);
    }

    let save = (resource) => {
      if (resource.save) {
          return resource.save();
      } else {
        return Restangular.all('admin/common_questions').post(resource);
      }
    }

    let update = (id, response) => {
      return Restangular.all('admin/common_questions').customPUT(response, id);
    }

    let deleteData = (id) => {
      return Restangular.all('admin/common_questions').customDELETE(id);
    }

    let index = (query) => {
      query = query || {};
      query.deleted_at = 'null';
      return ServiceAPI.getList(query);
    }

    let load = (query) => {
      return new Promise((resolve, reject) => {
        getFaqList(query)
          .then(response => {
              let count = response.length;
              index(query)
              .then(data => {
                  resolve({count, data});
              })
              .catch(err => {
                  reject(err);
              });
          })
          .catch(err => {
              reject(err);
          });
      });
    }

    load(null)

    let show = (id) => {
      return ServiceAPI.get(id);
    }

    let destroy = (resource) => {
      resource.deleted_at = moment();
      return resource.save();
    }

    return { index, load, save, update, deleteData, show, destroy, getLogDetails } ;
};

FaqService.$inject = ['Restangular'];

export default FaqService;



// WEBPACK FOOTER //
// ./client/app/components/faq/faq.service.js